// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CHVoJ","inner":"styles_inner__1O_xP","right":"styles_right__AunDG","close":"styles_close__1avSZ","footer":"styles_footer__2top3"};